import { createTheme } from "@mui/material/styles";

// Material UI design-system theme. Roboto + canonical Material blue, light/dark
// aware via CssBaseline. Kept declarative so the whole look is tunable here.
export const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: { main: "#1976d2" },
    secondary: { main: "#9c27b0" },
    success: { main: "#2e7d32" },
    error: { main: "#d32f2f" },
    background: { default: "#f4f6f8" },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: [
      "Roboto",
      "system-ui",
      "-apple-system",
      "Segoe UI",
      "Arial",
      "sans-serif",
    ].join(","),
    h4: { fontWeight: 700 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { textTransform: "none", fontWeight: 600 } },
    },
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: "none" } },
    },
  },
});
